import React from 'react';
import { setupIonicReact } from '@ionic/react';
import WebApp from './WebApp';

// Ionic React setup
setupIonicReact();

const App: React.FC = () => {
  return <WebApp />;
};

export default App; 